import * as MicrosoftTeams from '@microsoft/teams-js';
import { TeamsMsal2Provider } from '@microsoft/mgt-teams-msal2-provider';
import LimeadeLoader from '../components/shared/Loader/Loader';

export default function TeamsSSO() {
  TeamsMsal2Provider.microsoftTeamsLib = MicrosoftTeams;
  TeamsMsal2Provider.handleAuth();
  return <LimeadeLoader />;
}
